import React from "react";
import { View } from '../../../components/templates/View';
import { CDContinuidadElectrica, CMContinuidadElectrica } from '../organisms';
import { useViewport } from "../../../hooks";

const ContinuidadElectrica = () => {

    const { width } = useViewport();

    return(
        width > 850 ?
            <>
                <View children={ <CDContinuidadElectrica /> }/>
            </>
        :
            <>
                <View children={ <CMContinuidadElectrica/> }/>
            </>
    );
}

export default ContinuidadElectrica;

